//KtitleTheme
import { KtitTheme } from "../.internal/themes/KtitTheme";
export default KtitTheme;